import { render, staticRenderFns } from "./index-v2.vue?vue&type=template&id=3f1b78de&scoped=true"
import script from "./index-v2.vue?vue&type=script&setup=true&lang=js"
export * from "./index-v2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index-v2.vue?vue&type=style&index=0&id=3f1b78de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b78de",
  null
  
)

export default component.exports